import { API_PATH } from '~/utility/constants/api-path'

export function useTopTimeLimits() {
  const api = useNuxtApp().$api
  const entryDiscountTimeLimit = ref<string | null>(null)
  const entrySettlementTimeLimit = ref<string | null>(null)
  const entryPaymentUrl = ref<string | null>(null)
  const entryCampaign = ref<{ code: string; discount_amount: number; expires_at: string } | null>(null)

  const BannerNameForShowing = computed(() => {
    if (entrySettlementTimeLimit.value) {
      return 'settlement'
    } else if (entryCampaign.value) {
      return 'campaign'
    } else if (entryDiscountTimeLimit.value) {
      return 'discount'
    }
    return null
  })

  onMounted(async () => {
    try {
      const [resultEntrySettlementTimeLimit, resultEntryDiscountTimeLimit, resultEntryCampaign] = await Promise.all([
        api.get(API_PATH.ENTRY_SETTLEMENT_TIME_LIMIT),
        api.get(API_PATH.ENTRY_DISCOUNT_TIME_LIMIT),
        api.get(API_PATH.ENTRY_CAMPAIGN)
      ])

      entrySettlementTimeLimit.value = resultEntrySettlementTimeLimit?.data?.entry_settlement_time_limit
      entryPaymentUrl.value = resultEntrySettlementTimeLimit?.data?.payment_url

      entryDiscountTimeLimit.value = resultEntryDiscountTimeLimit?.data?.entry_discount_time_limit

      entryCampaign.value = resultEntryCampaign?.data?.entry_campaign || null
    } catch (error) {
      return false
    }
  })

  return {
    entryDiscountTimeLimit,
    entrySettlementTimeLimit,
    entryPaymentUrl,
    entryCampaign,
    BannerNameForShowing
  }
}
